import UIFetchService from '../Service/UIFetchService';
import auth from '../Service/AuthFetchService';

import React from 'react';
import { Tabs, Table, Input, Space, Button, Tag, Row, Col, Layout, Card, Skeleton, Divider,Collapse} from 'antd';
import {LeftOutlined } from '@ant-design/icons';
import Avatar from 'antd/lib/avatar/avatar';
import CollapsePanel from 'antd/lib/collapse/CollapsePanel';


class UserTagsView extends React.Component {

    render() {
        return <>
        {/* const tags1 = {this.props.dataSource.slice(0, parseInt((this.props.dataSource.length -1)/2))}
        const tags2 = {this.props.dataSource.slice(parseInt((this.props.dataSource.length-1)/2) + 1, this.props.dataSource.length-1)} */}
        {this.props.loading
            ? <Skeleton active />
            : <Row>
                <Col span={12}>{this.props.dataSource.slice(0, parseInt((this.props.dataSource.length -1)/2 + 1)).map(tag => <>
                    {(tag.value === undefined || tag.value === null)? 
                        <p style={{ fontSize: 14, color: 'gray', margin:'8px 0'}}>{tag.title}：<span style = {{color:'#434343'}}>未知</span></p>
                        :<p style={{ fontSize: 14, color: 'gray', margin:'8px 0'}}>{tag.title}：<span style = {{color:'#434343'}}>{tag.value}</span></p>}
                </>)}
                </Col>
                <Col span={12}>
                    {this.props.dataSource.slice(parseInt((this.props.dataSource.length-1)/2) + 1, this.props.dataSource.length).map(tag => <>
                        {(tag.value === undefined || tag.value === null)? 
                        <p style={{ fontSize: 14, color: 'gray', margin:'8px 0'}}>{tag.title}：<span style = {{color:'#434343'}}>未知</span></p>
                        :<p style={{ fontSize: 14, color: 'gray', margin:'8px 0'}}>{tag.title}：<span style = {{color:'#434343'}}>{tag.value}</span></p>}
                    </>)}
                </Col>
            </Row>
        }
        </>
    }
}

class UserDetailView extends React.Component {

    detailProperties = {
        'bcz_id': 'bczId',
        'cya_uid': 'cyaUid',
        'bcz_uid': 'bczUid',
        'wx_union_id': 'unionId',
        '手机号码': 'maskedPhone',
        '性别': 'sex',
        //'年龄': 'age',
        //'年龄段': 'ageStage',
        // '注册身份': 'registerIdentity',
        // '当前身份': 'currentIdentity',
        // '用户角色': 'roleUpName',
        // '用户年级': 'userGrade',
        '所在省份': 'province',
        '所在城市': 'city',
        '城市等级': 'cityLevel',
        '设备平台': 'deviceKind',
        '设备品牌': 'deviceBrand',
        '设备型号': 'deviceMode',
        '设备名称': 'deviceFullName',
        '设备价格': 'devicePrice'
    }

    constructor() {
        super();
        this.state = {
            bczUid: 0,
            userDetail: {
                baseProperties: {
                    wxOpenIds: {}
                },
                baseTags: []
            },
            orders: { loading: true, items: [] },
            apps: { loading: true, items: [] },
            courses: { loading: true, items: [] },
            categories: []
        };
    }

    componentDidMount() {
        this.fetchUserDetail(this.props.bczUid);
        auth.appendLog('UserDetailView', { bczUid: this.props.bczUid });
    }
    // 131618340
    render() {
        const baseProperties = this.state.userDetail.baseProperties;
        return <>
            <div style={{ height: '10px' }} />
            <Row style={{ textAlign: 'left', padding: '0 10px 0 10px', margin: '0 0 10px 0' }}>
                <Col>
                    <span
                        style={{
                            color: 'gray',
                            cursor: 'pointer'
                        }}
                        onClick={() => window.location = '/user_profile/users'}
                    ><LeftOutlined /> 返回</span>
                </Col>
            </Row>
            <Row style={{ textAlign: 'left', padding: '0 10px 0 10px', margin: '0 0 10px 0' }}>
            <Tabs defaultActiveKey="tags" style={{width:'100%'}}>
                <Tabs.TabPane tab="用户画像" key="tags">
                    <div style={{ height: '20px' }} />
                    <Row>
                        <Col style={{marginLeft: '10px'}}>
                            <Avatar size={80} src={baseProperties.avatarUrl} />
                        </Col>
                        <Col span={14} style={{ textAlign: 'start', alignSelf: 'center', wordBreak: 'break-all', marginLeft: '10px'}}>
                            <span style={{ fontSize: 17 }}>{
                                (baseProperties.nickname === null || baseProperties.nickname === undefined)
                                    ? '--' : baseProperties.nickname}
                            </span>
                        </Col>
                    </Row>
                    <Divider style={{margin:'10px 0'}}/>
                    <Row >
                        <Collapse defaultActiveKey={['1','2','3','4','5']} style={{width:'100%'}} expandIconPosition="right">
                            <Collapse.Panel header="基本信息" key="1">
                                {this.renderTagProperties('基本信息')}
                            </Collapse.Panel>
                            <CollapsePanel header="地理位置" key="2">
                                {this.renderTagProperties('地理位置')}
                            </CollapsePanel>
                            <CollapsePanel header="行为习惯" key="3">
                                {this.renderTagProperties('行为习惯')}
                            </CollapsePanel>
                            <CollapsePanel header="学习能力" key="4">
                                {this.renderTagProperties('学习能力')}
                            </CollapsePanel>
                            <CollapsePanel header="兴趣偏好" key="5">
                                {this.renderTagProperties('兴趣偏好')}
                            </CollapsePanel>
                        </Collapse>
                    </Row>
                </Tabs.TabPane>
                <Tabs.TabPane tab="应用信息" key="apps">
                    <Table
                        dataSource={this.state.apps.items}
                        loading={this.state.apps.loading}
                        bordered
                        scroll={{ x: 2200 }}
                        size='middle'
                        pagination={{defaultPageSize:15}}>
                        <Table.Column
                            title="应用名称"
                            dataIndex="appShowName"
                            key="appShowName"
                            fixed="left"
                            width={200}
                        />
                        <Table.Column
                            title="用户ID"
                            dataIndex="appUserId"
                            key="appUserId"
                            ellipsis
                            width={140}
                        />
                        <Table.Column
                            title="微信union_id"
                            dataIndex="bindWxUnionId"
                            key="bindWxUnionId"
                            ellipsis
                            width={300}
                        />
                        <Table.Column
                            title="微信open_id"
                            dataIndex="bindWxOpenId"
                            key="bindWxOpenId"
                            ellipsis
                            width={300}
                        />
                        <Table.Column
                            title="首次注册/关注时间"
                            dataIndex="appFirstRegisterTime"
                            key="appFirstRegisterTime"
                            width={180}
                        />
                        <Table.Column
                            title="最近注册/关注时间"
                            dataIndex="appLatestRegisterTime"
                            key="appLatestRegisterTime"
                            width={180}
                        />
                        <Table.Column
                            title="首次来源渠道"
                            dataIndex="appFirstRegisterFrom"
                            key="appFirstRegisterFrom"
                            ellipsis
                            width={120}
                        />
                        <Table.Column
                            title="最近来源渠道"
                            dataIndex="appLatestRegisterFrom"
                            key="appLatestRegisterFrom"
                            ellipsis
                            width={120}
                        />
                        <Table.Column
                            title="首次注销/取关时间"
                            dataIndex="appFirstUnregisterTime"
                            key="appFirstUnregisterTime"
                            width={180}
                        />
                        <Table.Column
                            title="最近注销/取关时间"
                            dataIndex="appLatestUnregisterTime"
                            key="appLatestUnregisterTime"
                            width={180}
                        />
                        <Table.Column
                            title="所属项目组"
                            dataIndex="projectGroupName"
                            key="projectGroupName"
                            width={130}
                            filters={
                                [{
                                    text: '百词斩',
                                    value: '百词斩'
                                }, {
                                    text: '薄荷芝士派',
                                    value: '薄荷芝士派'
                                }, {
                                    text: '蛋糕英语',
                                    value: '蛋糕英语'
                                }, {
                                    text: '电商团队',
                                    value: '电商团队'
                                }, {
                                    text: '柚子鸭',
                                    value: '柚子鸭'
                                }, {
                                    text: '夜曲编程',
                                    value: '夜曲编程'
                                }, {
                                    text: '大学数学',
                                    value: '大学数学'
                                }, {
                                    text: '其他',
                                    value: '其他'
                                }, {
                                    text: '未知',
                                    value: null
                                }]
                            }
                            onFilter={(value, record) => record.projectGroupName === value}
                        />
                        <Table.Column
                            title="应用类型"
                            dataIndex="appType"
                            key="appType"
                            filters={
                                [{
                                    text: 'APP',
                                    value: 'APP'
                                }, {
                                    text: '微信公众号',
                                    value: '微信公众号'
                                }, {
                                    text: '未知',
                                    value: null
                                }]
                            }
                            onFilter={(value, record) => record.appType === value}
                        />
                    </Table>
                </Tabs.TabPane>
                <Tabs.TabPane tab="订单明细" key="orders">
                    <Table
                        dataSource={this.state.orders.items}
                        loading={this.state.orders.loading}
                        bordered
                        scroll={{ x: 1500 }}
                        size='middle'
                        pagination={{defaultPageSize:15}}>
                        <Table.Column
                            title="订单ID"
                            dataIndex="orderId"
                            key="orderId"
                            fixed="left"
                            width={100}
                        />
                        <Table.Column
                            title="子订单ID"
                            dataIndex="subOrderId"
                            key="subOrderId"
                            fixed="left"
                            width={100}
                        />
                        <Table.Column
                            title="商品名称"
                            dataIndex="itemTitle"
                            key="itemTitle"
                            fixed="left"
                            ellipsis
                            width={200}
                        />
                        <Table.Column
                            title="子商品SKU"
                            dataIndex="subItemSku"
                            key="subItemSku"
                            ellipsis
                            width={180}
                        />
                        <Table.Column
                            title="存货ID"
                            dataIndex="stockId"
                            key="stockId"
                            ellipsis
                            width={120}
                        />
                        <Table.Column
                            title="订单状态"
                            dataIndex="subOrderStatusDesc"
                            key="subOrderStatusDesc"
                            width={100}
                            filters={
                                [{
                                    text: '已下单',
                                    value: '已下单'
                                }, {
                                    text: '待确认',
                                    value: '待确认'
                                }, {
                                    text: '已付款',
                                    value: '已付款'
                                }, {
                                    text: '已发货',
                                    value: '已发货'
                                }, {
                                    text: '已取消',
                                    value: '已取消'
                                }, {
                                    text: '已签收',
                                    value: '已签收'
                                }, {
                                    text: '已退款',
                                    value: '已退款'
                                }, {
                                    text: '待退款',
                                    value: '待退款'
                                }, {
                                    text: '已完成',
                                    value: '已完成'
                                }]
                            }
                            onFilter={(value, record) => record.subOrderStatusDesc === value}
                        />
                        <Table.Column
                            title="下单时间"
                            dataIndex="subItemOrderTime"
                            key="subItemOrderTime"
                            width={180}
                        />
                        <Table.Column
                            title="支付金额"
                            dataIndex="subItemPayment"
                            key="subItemPayment"
                            width={100}
                        />
                        <Table.Column
                            title="是否测试订单"
                            dataIndex="test"
                            key="test"
                            width={100}
                        />
                        <Table.Column
                            title="项目组名称"
                            dataIndex="projectGroupName"
                            key="projectGroupName"
                            width={130}
                            filters={
                                [{
                                    text: '百词斩',
                                    value: '百词斩'
                                }, {
                                    text: '薄荷芝士派',
                                    value: '薄荷芝士派'
                                }, {
                                    text: '蛋糕英语',
                                    value: '蛋糕英语'
                                }, {
                                    text: '电商团队',
                                    value: '电商团队'
                                }, {
                                    text: '柚子鸭',
                                    value: '柚子鸭'
                                }, {
                                    text: '夜曲编程',
                                    value: '夜曲编程'
                                }, {
                                    text: '其他',
                                    value: '其他'
                                }, {
                                    text: '未知',
                                    value: null
                                }]
                            }
                            onFilter={(value, record) => record.projectGroupName === value}
                        />
                    </Table>
                </Tabs.TabPane>
                <Tabs.TabPane tab="课程学习" key="courses">
                <Table
                        dataSource={this.state.courses.items}
                        loading={this.state.courses.loading}
                        bordered
                        scroll={{ x: 2000 }}
                        size='middle'
                        pagination={{defaultPageSize:15}}>
                        <Table.Column
                            title="学员ID"
                            dataIndex="studentId"
                            key="studentId"
                            fixed="left"
                            width={150}
                        />
                        <Table.Column
                            title="课程名称"
                            dataIndex="courseName"
                            key="courseName"
                            fixed="left"
                            width={200}
                        />
                        <Table.Column
                            title="加课方式"
                            dataIndex="addCourseType"
                            key="addCourseType"
                            width={100}
                        />
                        <Table.Column
                            title="课程所属项目组"
                            dataIndex="projectGroupName"
                            key="projectGroupName"
                            width={150}
                            filters={
                                [{
                                    text: '百词斩',
                                    value: '百词斩'
                                }, {
                                    text: '薄荷芝士派',
                                    value: '薄荷芝士派'
                                }, {
                                    text: '蛋糕英语',
                                    value: '蛋糕英语'
                                }, {
                                    text: '电商团队',
                                    value: '电商团队'
                                }, {
                                    text: '柚子鸭',
                                    value: '柚子鸭'
                                }, {
                                    text: '夜曲编程',
                                    value: '夜曲编程'
                                }, {
                                    text: '其他',
                                    value: '其他'
                                }, {
                                    text: '未知',
                                    value: null
                                }]
                            }
                            onFilter={(value, record) => record.projectGroupName === value}
                        />
                        <Table.Column
                            title="课程期数"
                            dataIndex="courseTermNum"
                            key="courseTermNum"
                            width={100}
                        />
                        <Table.Column
                            title="课程起始日期"
                            dataIndex="courseStartDate"
                            key="courseStartDate"
                            width={120}
                        />
                        <Table.Column
                            title="课程截止日期"
                            dataIndex="courseEndDate"
                            key="courseEndDate"
                            width={120}
                        />
                        <Table.Column
                            title="课程天数"
                            dataIndex="courseDays"
                            key="courseDays"
                            width={100}
                        />
                        <Table.Column
                            title="截止今日已学课时数量"
                            dataIndex="learnedLessonCntTd"
                            key="learnedLessonCntTd"
                            ellipsis
                            width={100}
                        />
                        <Table.Column
                            title="截止今日已完成课时数量"
                            dataIndex="finishedLessonCntTd"
                            key="finishedLessonCntTd"
                            ellipsis
                            width={100}
                        />
                        <Table.Column
                            title="截止今日解锁当日完成学习的课时数量"
                            dataIndex="finishedAtOpenDayLessonCntTd"
                            key="finishedAtOpenDayLessonCntTd"
                            ellipsis
                            width={100}
                        />
                        <Table.Column
                            title="该课是否学习完毕"
                            dataIndex="courseFinished"
                            key="courseFinished"
                            width={130}
                            filters={
                                [{
                                    text: '是',
                                    value: '是'
                                }, {
                                    text: '否',
                                    value: '否'
                                }, {
                                    text: '未学完',
                                    value: '未学完'
                                }, {
                                    text: '未知',
                                    value: null
                                }]
                            }
                            onFilter={(value, record) => record.courseFinished === value}
                        />
                    </Table>
                </Tabs.TabPane>
                {/* <Tabs.TabPane tab="行为路径" key="actions">

                </Tabs.TabPane> */}
            </Tabs>
            </Row>
        </>
    }

    renderTagProperties(category) {
        const item = this.state.userDetail[category];
        if (item === undefined) {
            return <></>
        }
        return <UserTagsView loading={item.loading} title={item.title} dataSource={item.children} />
    }

    renderPropertyItem(title) {
        const baseProperties = this.state.userDetail.baseProperties;
        const value = baseProperties[this.detailProperties[title]];
        return <>
            <Row>
                <Col>
                    <span style={{ fontSize: 12, color: 'gray' }}>{title}</span>
                </Col>
            </Row>
            <Row>
                <Col>
                    {(value === undefined || value === null)
                        ? <span style={{ fontSize: 15, color: 'gray' }}>未知</span>
                        : <span style={{ fontSize: 15 }}>{value}</span>}
                </Col>
            </Row>
            <div style={{ height: '10px' }} />
        </>
    }

    async fetchUserDetail(bczUid) {
        this.setState({bczUid : bczUid})
        const baseProperties = await UIFetchService.get(`/api/v1/user_profile/users/${bczUid}/base_properties`);
        if (!baseProperties) {
            return;
        }

        const userDetail = this.state.userDetail;
        userDetail.baseProperties = baseProperties;

        const categories = await UIFetchService.get(`/api/v1/user_profile/tags/categories?exclude=${encodeURI('无')}`);
        if (!categories) {
            return;
        }
        const state = this.state.userDetail;
        for (let category of categories) {
            state[category] = {
                title: category,
                key: category,
                loading: true,
                children: []
            };
            this.fetchUserTags(category);
        }

        UIFetchService.get(`/api/v1/user_profile/users/${bczUid}/orders`)
            .then(orders => {
                const state = this.state.orders;
                state.loading = false;
                state.items = orders;
                this.setState({ orders: state });
            });

        UIFetchService.get(`/api/v1/user_profile/users/${bczUid}/apps`)
            .then(apps => {
                const state = this.state.apps;
                state.loading = false;
                state.items = apps;
                this.setState({ apps: state });
            });
        
        UIFetchService.get(`/api/v1/user_profile/users/${bczUid}/courses`)
            .then(courses => {
                const state = this.state.courses;
                state.loading = false;
                state.items = courses;
                this.setState({ courses: state });
            });
        this.setState({ showDetail: true, userDetail: state, categories: categories });
    }

    buildBaseTags(baseProperties) {
        const value = (raw) => raw === undefined || raw === null ? null : raw;
        const tags = [
            {
                title: '注册日期',
                key: 'registerDay',
                value: value(baseProperties.registerDay)
            }, /*{
                title: '生日',
                key: 'birthDay',
                value: value(baseProperties.birthDay)
            }, *//*{
                title: '教育程度',
                key: 'education',
                value: value(baseProperties.education)
            }, */{
                title: '身份',
                key: 'identity',
                value: value(baseProperties.identity)
                // '注册身份': 'registerIdentity',
                // '当前身份': 'currentIdentity',
                // '用户角色': 'roleUpName',
                // '用户年级': 'userGrade',
            }, {
                title: '注册身份',
                key: 'registerIdentity',
                value: value(baseProperties.registerIdentity)
            }, {
                title: '当前身份',
                key: 'currentIdentity',
                value: value(baseProperties.currentIdentity)
            }, {
                title: '用户角色',
                key: 'roleUpName',
                value: value(baseProperties.roleUpName)
            }, {
                title: '用户年级',
                key: 'userGrade',
                value: value(baseProperties.userGrade)
            }, /*//*{
                title: '学校专业',
                key: 'schoolMajor',
                value: value(baseProperties.schoolMajor)
            }, *//*{
                title: '入学年份',
                key: 'schoolYear',
                value: value(baseProperties.schoolYear)
            }, */{
                title: '是否有小孩',
                key: 'hasChildren',
                value: value(baseProperties.hasChildren)
            }, /*{
                title: '小孩生日',
                key: 'childBirtyday',
                value: value(baseProperties.childBirtyday)
            }, */{
                title: '小孩性别',
                key: 'childSex',
                value: value(baseProperties.childSex)
            }, {
                title: '是否内部员工',
                key: 'isInternalWorker',
                value: value(baseProperties.isInternalWorker)
            }, {
                title: '集团下单用户',
                key: 'hasGroupOrder',
                value: value(baseProperties.hasGroupOrder)
            }, {
                title: '实体商品下单用户',
                key: 'hasShopOrder',
                value: value(baseProperties.hasShopOrder)
            }, {
                title: '百词斩课程下单用户',
                key: 'hasBczCourseOrder',
                value: value(baseProperties.hasBczCourseOrder)
            }, {
                title: '薄荷课程下单用户',
                key: 'hasMintCourseOrder',
                value: value(baseProperties.hasMintCourseOrder)
            }, {
                title: '夜曲课程下单用户',
                key: 'hasNocturneCourseOrder',
                value: value(baseProperties.hasNocturneCourseOrder)
            }, {
                title: '柚子鸭课程下单用户',
                key: 'hasKidsCourseOrder',
                valule: value(baseProperties.hasKidsCourseOrder)
            }, {
                title: '蛋糕课程下单用户',
                key: 'hasCakeCourseOrder',
                value: value(baseProperties.hasCakeCourseOrder)
            }, {
                title: '集团总计消费金额:',
                key: 'totalFee',
                value: value(baseProperties.totalFee)
            }
        ];
        const state = this.state.userDetail;
        state.baseTags = tags;// [{ title: '集团标签', key: 'base', children: tags }];
        this.setState({ userDetail: state });
    }

    fetchUserTags(category) {
        const bczUid = this.state.bczUid;
        UIFetchService.get(`/api/v1/user_profile/users/${bczUid}/${encodeURI(category)}/tags`)
            .then((tags) => {
                const state = this.state.userDetail;
                state[category].children = tags;
                state[category].loading = false;
                this.setState({ userDetail: state });
            });
    }
}

export default UserDetailView;